import React from 'react'

import { Field } from 'formik'

import { Form } from '_zari/core'

const FlagGrifoFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Field name='flagGrifo'>
      {({ field }) => <Form.Checkbox {...field} checked={iValue} disabled={fIsSubmitting} id='checkbox-flagGrifo' label='Es Grifo' />}
    </Field>
  )
}

export default React.memo(FlagGrifoFormGroup)
